// The specific reasons this module's backend gives, in the four languages.
//
// Two codes travel INSIDE an error and are not the code it is thrown with:
//
//   · `reasons` — what a generic refusal carries in `details.reason` or
//     `details.code` (`ConflictError(…, 'CONFLICT', { reason: 'ALREADY_CLOSED' })`).
//     errorMessage() says it from `errors.reasons.<REASON>` instead of the
//     generic «that record is no longer in the state you expected».
//   · `fields` — the code of each field of a ValidationError, said by
//     fieldErrors() from `errors.fields.<CODE>` instead of «not a valid value».
//
// Generic field codes (EMPTY, IN_THE_FUTURE, NOT_FOUND…) are the shell's and
// are not repeated here. platform/web/tests/errorReasons.test.js reads the
// backend and fails on a code without its four sentences, and on two
// modules saying one code differently (the shell merges them into one).

const errorReasons = {
  es: {
    reasons: {
      ORIGIN_TAKEN: 'Ese registro del otro sistema ya se importó',
      ORIGIN_CHANGED: 'Ese registro del otro sistema ya se importó con otros datos',
    },
  },
  ca: {
    reasons: {
      ORIGIN_TAKEN: 'Aquest registre de l’altre sistema ja es va importar',
      ORIGIN_CHANGED: 'Aquest registre de l’altre sistema ja es va importar amb altres dades',
    },
  },
  en: {
    reasons: {
      ORIGIN_TAKEN: 'That record from the other system was already imported',
      ORIGIN_CHANGED: 'That record from the other system was already imported with different data',
    },
  },
  fr: {
    reasons: {
      ORIGIN_TAKEN: 'Cet enregistrement de l’autre système a déjà été importé',
      ORIGIN_CHANGED: 'Cet enregistrement de l’autre système a déjà été importé avec d’autres données',
    },
  },
}

/** The module's catalogue with these hung from `errors`, locale by locale. */
export function withErrorReasons(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    const own = errorReasons[locale] ?? {}
    merged[locale] = {
      ...catalogue,
      errors: {
        ...catalogue.errors,
        reasons: { ...catalogue.errors?.reasons, ...own.reasons },
        fields: { ...catalogue.errors?.fields, ...own.fields },
      },
    }
  }
  return merged
}

export default errorReasons
